// Stable, machine-readable error codes returned to the renderer.
// Renderer maps these to localised messages.
export const ERROR_CODES = {
  AUTH_REQUIRED: 'AUTH_REQUIRED',
  AUTH_INVALID_TOKEN: 'AUTH_INVALID_TOKEN',
  AUTH_INVALID_CREDENTIALS: 'AUTH_INVALID_CREDENTIALS',
  AUTH_EMAIL_NOT_VERIFIED: 'AUTH_EMAIL_NOT_VERIFIED',
  AUTH_RATE_LIMITED: 'AUTH_RATE_LIMITED',
  FORBIDDEN: 'FORBIDDEN',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  NOT_FOUND: 'NOT_FOUND',
  CONFLICT: 'CONFLICT',
  INVITE_DOMAIN_NOT_ALLOWED: 'INVITE_DOMAIN_NOT_ALLOWED',
  INVITE_EXPIRED: 'INVITE_EXPIRED',
  INVITE_ALREADY_REDEEMED: 'INVITE_ALREADY_REDEEMED',
  ATTACHMENT_TOO_LARGE: 'ATTACHMENT_TOO_LARGE',
  ATTACHMENT_TYPE_REJECTED: 'ATTACHMENT_TYPE_REJECTED',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

export interface ApiErrorBody {
  code: ErrorCode;
  message: string;
  details?: unknown;
}
